import axios from 'axios';
import StackTrace from 'sourcemapped-stacktrace';
import withConfig from 'with-config';
import config from '../config';

export function fetchMyself() {
  let token = window.sso.getJWT();
  return apiCall(config.api.sso.api_uri + '/users/' + token.getClaim('uid'));
}

export function sendMessageToSlack(
  msg_to_send,
  err = null,
  component_trace = null,
) {
  //Use component_trace when posting from react ErrorBoundary.
  if (
    withConfig.getConfig().production === false &&
    withConfig.getConfig().send_errors_to_slack_in_dev !== true
  ) {
    return;
  }
  let msg = 'DASHBOARD: ' + msg_to_send;
  if (err) {
    msg += '\nERROR: ' + err.message + '\n';
    if (component_trace) {
      msg += '\n' + component_trace + '\n-----\n';
    }
    StackTrace.mapStackTrace(err.stack, resolved_trace => {
      msg += resolved_trace;
      postToSlack(msg);
    });
  } else {
    postToSlack(msg);
  }
}

export function fetchSSOSpecs() {
  return apiCall(config.api.sso.api_uri + '/specs');
}

function apiCall(url, method = 'GET', data = null) {
  let stack = new Error().stack;
  return new Promise((resolve, reject) => {
    const jwt_token = window.sso.getJWT().getRaw();
    let req = {
      url: url,
      method: method,
      headers: {
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    if (data) {
      req.data = data;
    }
    axios(req)
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        err.stack = stack;
        err.network_error = true;
        return reject(err);
      });
  });
}

function postToSlack(msg) {
  let payload = encodeURIComponent(JSON.stringify({text: msg}));
  axios({
    url: withConfig.getConfig().api.slack.webhook_uri,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    data: 'payload=' + payload,
  })
    .then(res => {
      console.log('Successfully sent debug message to slack.');
    })
    .catch(err => {
      console.error('Failed to send debug message to slack.');
    });
}



// WEBPACK FOOTER //
// ./src/helpers/api_helpers.js